import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 66 66">
    <g id="Page-1">
      <g id="Wi-Fi">
        <path
          id="Shape"
          style={{ fill: color }}
          d="M11.6,46.5c-1.1,0-2.2,0.3-3.1,0.9c-0.9,0.6-1.6,1.5-2,2.5c-0.4,1-0.5,2.1-0.3,3.2
				c0.2,1.1,0.7,2.1,1.5,2.8c0.8,0.8,1.7,1.3,2.8,1.5c1.1,0.2,2.2,0.1,3.2-0.3c1-0.4,1.9-1.1,2.5-2c0.6-0.9,0.9-2,1-3.1
				c0-0.7-0.1-1.5-0.4-2.1c-0.3-0.7-0.7-1.3-1.2-1.8c-0.5-0.5-1.1-0.9-1.8-1.2C13,46.6,12.3,46.5,11.6,46.5z M11.6,55.6
				c-0.5,0-0.9-0.1-1.4-0.2c-0.4-0.2-0.8-0.4-1.2-0.8c-0.3-0.3-0.6-0.7-0.8-1.2C8.1,53,8,52.5,8,52.1c0-0.7,0.3-1.5,0.7-2.1
				s1.1-1.1,1.8-1.3v3.4c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7v-3.3
				c0.7,0.2,1.4,0.6,1.8,1.2c0.5,0.6,0.7,1.3,0.7,2.1c0,0.5-0.1,0.9-0.2,1.4c-0.2,0.4-0.4,0.8-0.7,1.2c-0.3,0.3-0.7,0.6-1.1,0.8
				C12.5,55.5,12,55.6,11.6,55.6z"
        />
        <path
          id="Path"
          style={{ fill: color }}
          d="M39.2,24.1c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3-0.1-0.4
				c-0.1-0.1-0.1-0.2-0.2-0.3c-1.4-1.4-2.5-3-3.2-4.8c-0.8-1.8-1.1-3.7-1.1-5.7c0-1.9,0.4-3.9,1.1-5.7c0.8-1.8,1.9-3.4,3.2-4.8
				c0.2-0.2,0.3-0.5,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7C38.9,0.1,38.7,0,38.4,0c-0.3,0-0.5,0.1-0.7,0.3c-3.1,3.2-4.9,7.5-4.9,12
				c0,4.5,1.8,8.8,4.9,12c0.2,0.2,0.5,0.2,0.7,0.2C38.7,24.4,39,24.3,39.2,24.1z"
        />
        <path
          id="Path_1_"
          style={{ fill: color }}
          d="M41.3,20.5c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1
				c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3C43,20.1,43,20,43,19.8c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.1-0.2-0.2-0.3
				c-1.8-1.8-2.9-4.3-2.9-6.9s1-5.1,2.9-6.9C42.8,5.1,42.9,5,43,4.9C43,4.8,43,4.6,43,4.5c0-0.1,0-0.3-0.1-0.4
				c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.2
				c-1.1,1.1-2,2.4-2.6,3.8c-0.6,1.4-0.9,3-0.9,4.5c0,1.6,0.3,3.1,0.9,4.5C39.3,18.1,40.2,19.5,41.3,20.5z"
        />
        <path
          id="Path_2_"
          style={{ fill: color }}
          d="M44.9,17c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1
				c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4s0-0.3-0.1-0.4c-0.1-0.1-0.1-0.2-0.2-0.3
				c-0.9-0.9-1.4-2.1-1.4-3.4s0.5-2.5,1.4-3.4c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4s0-0.3-0.1-0.4
				c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2C45.9,7.1,45.7,7,45.6,7c-0.1,0-0.3,0-0.4,0.1c-0.1,0.1-0.2,0.1-0.3,0.2
				c-0.6,0.6-1.1,1.4-1.5,2.2c-0.3,0.8-0.5,1.7-0.5,2.6s0.2,1.8,0.5,2.6C43.7,15.6,44.2,16.3,44.9,17z"
        />
        <path
          id="Shape_1_"
          style={{ fill: color }}
          d="M61,41.5h-2.7V38c0-0.1,0-0.3-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2
				c-0.1,0-0.3-0.1-0.4-0.1h-4.8V15.7c0.8-0.2,1.4-0.7,1.9-1.3c0.5-0.6,0.7-1.4,0.7-2.2c0-1-0.4-1.9-1.1-2.6
				c-0.7-0.7-1.6-1.1-2.6-1.1c-1,0-1.9,0.4-2.6,1.1c-0.7,0.7-1.1,1.6-1.1,2.6c0,0.8,0.3,1.6,0.7,2.2s1.2,1.1,1.9,1.3v21.1h-4.8
				c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1-0.1,0.3-0.1,0.4v3.5H4.4c-0.6,0-1.2,0.1-1.7,0.3
				c-0.5,0.2-1,0.5-1.4,0.9c-0.4,0.4-0.7,0.9-1,1.4C0.1,44.6,0,45.2,0,45.8v12.6c0,0.6,0.1,1.2,0.3,1.7c0.2,0.5,0.5,1,1,1.4
				c0.4,0.4,0.9,0.7,1.4,1c0.5,0.2,1.1,0.3,1.7,0.3h4v1.5c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3
				c0.2-0.2,0.3-0.5,0.3-0.7v-1.5h44.7v1.5c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3
				c0.2-0.2,0.3-0.5,0.3-0.7v-1.5h4c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1-0.5,1.4-1c0.4-0.4,0.7-0.9,1-1.4c0.2-0.5,0.3-1.1,0.3-1.7V45.9
				c0-1.2-0.5-2.3-1.4-3.1C63.3,42,62.2,41.5,61,41.5z M50,12.2c0-0.3,0.1-0.6,0.3-0.9c0.2-0.3,0.4-0.5,0.7-0.6
				c0.3-0.1,0.6-0.2,0.9-0.1c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.4,0.5,0.5,0.8c0.1,0.3,0,0.6-0.1,1c-0.1,0.3-0.3,0.6-0.6,0.7
				c-0.3,0.2-0.6,0.3-0.9,0.3c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.4-0.2-0.5-0.4c-0.2-0.2-0.3-0.3-0.4-0.5S50,12.4,50,12.2z M46.8,38.9
				h9.5v2.6h-9.5V38.9z M63.4,58.4c0,0.6-0.2,1.2-0.7,1.7c-0.4,0.4-1,0.7-1.7,0.7H4.4c-0.6,0-1.2-0.2-1.7-0.7c-0.4-0.4-0.7-1-0.7-1.7
				V45.9c0-0.6,0.2-1.2,0.7-1.7s1-0.7,1.7-0.7h56.8c0.6,0,1.2,0.2,1.7,0.7c0.4,0.4,0.7,1,0.7,1.7v12.5H63.4z"
        />
        <path
          id="Path_3_"
          style={{ fill: color }}
          d="M36.9,54.9c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4
				C34.5,53.8,35.6,54.9,36.9,54.9z"
        />
        <path
          id="Path_4_"
          style={{ fill: color }}
          d="M46.1,54.9c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4
				C43.7,53.8,44.8,54.9,46.1,54.9z"
        />
        <path
          id="Path_5_"
          style={{ fill: color }}
          d="M55.5,54.9c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4S53,51.1,53,52.4
				C53,53.8,54.1,54.9,55.5,54.9z"
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/Wi-Fi.js